import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { MyService } from 'src/app/my.service';
import { AuthService } from '../Services/auth.service';

import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit  {
  // loginData = { username: '', password: '' };
  // error = '';

  model: any = {};

  isLoggedIn: boolean = false;
  isAdmin: boolean = false;
  isEditor: boolean = false;
  // successMessage = ''; // ✅ پیام موفقیت

  constructor(private http: HttpClient, private router: Router, private authService:AuthService,
     private toastr: ToastrService) {}
// this.authService.register(this.registerData)
//       .subscribe({

ngOnInit(): void {
  this.authService.isLoggedIn$.subscribe(status => {
    this.isLoggedIn = status;
    this.isAdmin = status ? this.authService.isAdmin() : false;
  });
}
// login() {
//     this.authService.login(this.loginData).subscribe({
//       next: (res: any) => {
//         // console.log('ورود موفقیت‌آمیز:', res);
//         // ذخیره توکن و هدایت
//         this.authService.saveToken(res.token);

//         // ✅ نمایش پیام موفقیت
//         this.successMessage = 'ورود با موفقیت انجام شد';

//         // ✅ هدایت پس از تأخیر
//         setTimeout(() => {
//           this.router.navigate(['/']);
//         }, 1500); // 1.5 ثانیه تأخیر برای نمایش پیام
//       },
//       error: (error) => {
//         console.error('خطا در ورود:', error);
//         alert('نام کاربری یا رمز عبور اشتباه است');
//       }
//     });
//   }


  login() {
    this.authService.login(this.model).subscribe({
      next: () => {
        this.isLoggedIn = true;
        this.isAdmin = this.authService.isAdmin(); // نقش رو هم بررسی کن

         this.isEditor = this.authService.isEditor(); 
        // const isManager = this.authService.isManager();

        this.model = {}; // پاک کردن فرم

        this.toastr.success('خوش آمدید!', 'ورود موفق');  // 🎉 پیام خوش‌آمد

        this.router.navigateByUrl('/'); // یا مسیر دلخواه
      },
      error: (err) => {
        console.error(err);
        // alert('ورود ناموفق!'); // بهتره از Toastr استفاده کنی
        this.toastr.error('نام کاربری یا رمز اشتباه است!', 'ورود ناموفق');

      }
    });
  }
logout() {
  this.authService.logout();
  // console.log("کاربر خارج شد"); // بررسی کن در Console مرورگر میاد یا نه
}

  getAdminData() {
    const token = localStorage.getItem('getToken');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get('https://cdick.ir/admin-data', { headers });
  }

}

